/* eslint-disable */
import React from "react"
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import { useState } from 'react'

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch'
    }
  },
  boton: {
  },
  inputRoot: {
    fontSize: 70
  },
  labelRoot: {
    fontSize: 50,
    color: "green",
    "&$labelFocused": {
      color: "purple"
    }
  },
  labelFocused: {}
}))

export default function MenuDeMuestrasIngreso(props) {
  const classes = useStyles()
  const [muestraIngreso, setMuestraIngreso] = useState('')
  const handleChange = (muestraIngreso) => {
    if (/^\d{0,15}$/.test(muestraIngreso.target.value)) { 
      setMuestraIngreso(muestraIngreso.target.value)
      props.setNumeroDeMuestra(muestraIngreso.target.value)
    } 
  }
  const handleKeyPress = (muestraIngreso) => {
    if (muestraIngreso.key==="Enter"){
      if (/^\d{15}$/.test(muestraIngreso.target.value)) {
        props.setDatos(muestraIngreso.target.value)
        setMuestraIngreso('')
      }
  }}
  return (  
    <TextField
      autoFocus
      InputProps={{ classes: { root: classes.inputRoot } }}
      InputLabelProps={{
        classes: {
          root: classes.labelRoot,
          focused: classes.labelFocused
        }
      }}
      onChange={handleChange}
      onKeyPress={handleKeyPress}
      value={muestraIngreso}
      id='outlined-basic'
      label='Número de Muestra'
      variant='outlined'
    />
  )
}

